import React from 'react';
import { Button } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { setScreenType, useCallNumber } from '../../../store/slices/dialSlice';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';
import { convertToMask } from '../../../utils/common';
import { useUserDetails } from '../../../store/slices/authSlice';
import { useTranslation } from 'react-i18next';

const AgentTransferScreen = ({ number }) => {
  const { t } = useTranslation();
  const user = useUserDetails();
  const callNumber = useCallNumber();

  const dispatch = useDispatch();

  return (
    <div className="h-100 call-action-btn-container">
      <div className="mt-auto mb-auto text-white text-center fw-bold fs-4">
        {user?.process_details?.numberMasking === 'true'
          ? convertToMask(callNumber || number)
          : callNumber || number}
      </div>

      <div className="text-center text-white transfer-call-button-grid mb-auto">
        <div className="d-flex flex-column align-items-center">
          <Button
            color="dark"
            className="mb-1"
            onClick={() => dispatch(setScreenType('BLIND_TRANSFER'))}>
            <i className="bi bi-telephone-forward-fill" />
          </Button>
          <span>{t('blindTransfer')}</span>
        </div>
        <div className="d-flex flex-column align-items-center">
          <Button
            color="dark"
            className="mb-1"
            onClick={() => dispatch(setScreenType('ATTENDED_TRANSFER'))}>
            <i className="bi bi-telephone-plus-fill" />
          </Button>
          <span>{t('attendedTransfer')}</span>
        </div>
      </div>
      <div className="call-button-wrapper mt-auto pb-4">
        <Button
          className="back-button"
          onClick={() => {
            dispatch(setScreenType('TRANSFER'));
          }}>
          <Icon.ArrowLeft className="back-icon text-primary" />
        </Button>
      </div>
    </div>
  );
};

AgentTransferScreen.propTypes = {
  number: PropTypes.string
};

export default AgentTransferScreen;
